export default [

      {
          path: '/service/database-schema/:databaseConfigId?',
          props: true,
          name: 'ServiceMetaDataSchema',
          component: () => import("@/views/Page/DatabaseService/MetaDataSchema/MetaDataSchema.vue"),
           meta: {
               title: 'Meta Data Schema',
          },
     },
     {
          path: '/service/database-schema/detail/:databaseSchemaId',
          name: 'ServiceMetaDataSchemaDetail',
          props: true,
          component: () => import("@/views/Page/DatabaseService/MetaDataSchema/MetaDataSchemaDetail.vue"),
           meta: {
               title: 'Meta Data Schema Detail',
          },
     },
     {
          path: '/service/database-schema/detail-csv/:databaseSchemaId',
          name: 'ServiceMetaDataSchemaDetailCsv',
          props: true,
          component: () => import("@/views/Page/DatabaseService/MetaDataSchema/MetaDataSchemaDetailCsv.vue"),
           meta: {
               title: 'Meta Data Schema Detail CSV',
          },
     },
     {
          path: '/service-database',
          name: 'ServiceDatabase',
          props: true,
          component: () => import("@/views/Page/DatabaseService/DatabaseService.vue"),
           meta: {
               title: 'Database Service',
          },
     }
];